import React, {Component} from 'react';
import { withStyles} from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

const styles = theme => ({

});

export default withStyles(styles)((props) => {
    const {
        toggleAlert,
        closeAlert
    } = props;

    return (
        <Snackbar open={toggleAlert.alert}
                  anchorOrigin={{ vertical: "top", horizontal: "center" }}
                  autoHideDuration={4000}
                  onClose={closeAlert}>
            <Alert onClose={closeAlert}
                   severity={toggleAlert.type || "error"}>
                {toggleAlert.message}
            </Alert>
        </Snackbar>
    )
});